import { useState } from "react";
import DeeperLookIcon_Trans from "../../../assets/UI/DeeperLookIcon_Trans.png";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";
import "../DeeperLook.css"; 


export default function TimeDLook() {

const categories = {

     Time_DL_Overview: {
 
         title: "Overview",
         content:[
                 { type: "subheader", content: "Introduction" },
                 { type: "paragraph", content: "Time is an essential part of daily life—whether you’re asking when something happens, telling the clock time, or talking about days and months. In Korean, time expressions combine both Native Korean numbers and Sino-Korean numbers, so it’s a great way to practice both systems together. This deck will guide you through reading the clock, talking about days and months, and using common time expressions in conversation." },
                         
        ]
     },
         
 
     HoursAndMinutes:{
         
         title: "Hours and Minutes",
         content:[    
             { type: "subheader", content: "Hours and Minutes" },
             { type: "paragraph", content: "In Korean, telling the clock time uses both number systems:" },
             { type: "list", items: 
                    [
                        "Native Korean numbers → hours (시, si)", 
                        "Sino-Korean numbers → minutes (분, bun)", 
                    ] 
              },
              { type: "subheader", content: "Basic Structure" },
              { type: "paragraph", content: "[Hour (Native)] 시 [Minute (Sino)] 분" },
              { type: "subheader", content: "Examples" },
              { type: "list", items: 
                    [
                        "세 시 → 3 o’clock", 
                        "네 시 십오 분 → 4:15", 
                        "열두 시 삼십 분 → 12:30",
                    ] 
              },
              { type: "paragraph", content: "For half past the hour, you can also say 반 (ban) instead of “30 minutes" },
              { type: "list", items: 
                  [
                      "두 시 반 → 2:30", 
                  ] 
              },
              { type: "subheader", content: "Adding A.M. / P.M." },
              { type: "list", items: 
                  [
                      "오전 (ojeon) = A.M.", 
                      "오후 (ohu) = P.M.", 
                      "Example: 오전 일곱 시 → 7 a.m.",
                      "오후 세 시 반 → 3:30 p.m."
                  ] 
              }        
         ]
     },
     DaysOfTheWeek: {
      title: "Days of the Week",
      content: [
            { type: "subheader", content: "Days of the Week" },
            { type: "paragraph", content: "The days of the week in Korean are based on natural elements like the sun, moon, and planets. All of them end with 요일 (yo-il), which means “day of the week.”" },
            { type: "subheader", content: "Days in Order" },
            { type: "list", items: [
                "월요일 (wol-yo-il) → Monday (moon day)",
                "화요일 (hwa-yo-il) → Tuesday (fire day / Mars)",
                "수요일 (su-yo-il) → Wednesday (water day / Mercury)",
                "목요일 (mok-yo-il) → Thursday (wood day / Jupiter)",
                "금요일 (geum-yo-il) → Friday (gold/metal day / Venus)",
                "토요일 (to-yo-il) → Saturday (earth day / Saturn)",
                "일요일 (il-yo-il) → Sunday (sun day)"
            ] 
            },
            { type: "subheader", content: "Examples" },
            { type: "list", items: [
                "오늘은 수요일이에요. → Today is Wednesday.",
                "내일은 금요일이에요. → Tomorrow is Friday.",
                "토요일에 만나요. → Let’s meet on Saturday."
            ] },
            { type: "paragraph", content: "Just add 에 (e) after the day to say “on [day].”" },
            { type: "subheader", content: "Try It Yourself!" },
            { type: "paragraph", content: "Try saying what day of the week it is today in Korean." }
      ]
  },
  MonthsAndDates: {
    title: "Months and Dates",
    content: [
        { type: "subheader", content: "Months and Dates" },
        { type: "paragraph", content: "Korean months and dates use Sino-Korean numbers, making them straightforward once you know the number system." },
        { type: "subheader", content: "Months" },
        { type: "paragraph", content: "All months are numbered, followed by 월 (wol), meaning “month.”" },
        { type: "list", items: [
            "1월 → January",
            "2월 → February",
            "3월 → March",
            "4월 → April",
            "5월 → May",
            "6월 → June",
            "7월 → July",
            "8월 → August",
            "9월 → September",
            "10월 → October",
            "11월 → November",
            "12월 → December"
        ] },
        { type: "subheader", content: "Dates" },
        { type: "paragraph", content: "To say the day of the month, use the number + 일 (il)." },
        { type: "list", items: [
            "1일 → 1st",
            "15일 → 15th",
            "30일 → 30th"
        ] },
        { type: "subheader", content: "Examples" },
        { type: "list", items: [
            "내 생일은 7월 10일이에요. → My birthday is July 10th.",
            "회의는 3월 21일이에요. → The meeting is on March 21st."
        ] },
        { type: "paragraph", content: "Tip: For months and dates, always use Sino-Korean numbers." },
        { type: "subheader", content: "Try It Yourself" },
        { type: "paragraph", content: "Say today’s date in Korean out loud to get familiar with the pattern." }
    ]
  },

  TimeExpressions: {
    title: "Time Expressions",
    content: [
        { type: "subheader", content: "Time Expressions" },
        { type: "paragraph", content: "Korean has many useful words to talk about when something happens. These expressions are essential for everyday conversation." },
        { type: "subheader", content: "Common Words" },
        { type: "list", items: [
            "오늘 (oneul) → today",
            "어제 (eo-je) → yesterday",
            "내일 (nae-il) → tomorrow",
            "모레 (mo-re) → the day after tomorrow",
            "그저께 (geu-je-kke) → the day before yesterday"
        ] },
        { type: "subheader", content: "Weeks, Months, and Years" },
        { type: "list", items: [
            "이번 주 (i-beon ju) → this week",
            "다음 주 (da-eum ju) → next week",
            "지난 주 (ji-nan ju) → last week",
            "올해 (ol-hae) → this year",
            "내년 (nae-nyeon) → next year",
            "작년 (jak-nyeon) → last year"
        ] },
        { type: "subheader", content: "Examples" },
        { type: "list", items: [
            "어제 뭐 했어요? → What did you do yesterday?",
            "내일 만날 거예요. → I will meet (you) tomorrow.",
            "다음 달에 여행 가요. → I’m going on a trip next month."
        ] },
        { type: "paragraph", content: "Tip: Combining these expressions with days of the week or clock times makes your sentences much more natural." }
    ]
},

AgeAndTimePeriods: {
    title: "Talking About Age and Time Periods",
    content: [
        { type: "subheader", content: "Talking About Age and Time Periods" },
        { type: "paragraph", content: "Korean uses numbers to express age, durations, and time spans. Knowing how to combine numbers with the right words makes your sentences accurate and natural." },
        { type: "subheader", content: "Age" },
        { type: "paragraph", content: "살 (sal) → years old" },
        { type: "paragraph", content: "Native Korean numbers are commonly used for age:" },
        { type: "list", items: [
            "스무 살 → 20 years old",
            "열여섯 살 → 16 years old"
        ] },
        { type: "paragraph", content: "Example: 저는 스물다섯 살이에요. → I am 25 years old." },
        { type: "subheader", content: "Duration" },
        { type: "list", items: [
            "시간 (sigan) → hours",
            "일 (il) → days",
            "주 (ju) → weeks",
            "달 / 개월 (dal / gaewol) → months",
            "년 / 해 (nyeon / hae) → years"
        ] },
        { type: "subheader", content: "Examples" },
        { type: "list", items: [
            "한 시간 동안 공부했어요. → I studied for one hour.",
            "세 주 동안 여행했어요. → I traveled for three weeks.",
            "두 달 동안 한국어를 배웠어요. → I learned Korean for two months."
        ] },
        { type: "paragraph", content: "Tip: Use Native Korean numbers for hours, days, and weeks, but Sino-Korean numbers for months and years." }
    ]
  },

  CommonTimePhrases: {
    title: "Common Phrases with Time",
    content: [
        { type: "subheader", content: "Common Phrases with Time" },
        { type: "paragraph", content: "Learning common time-related phrases helps you communicate naturally about schedules, plans, and events." },
        { type: "subheader", content: "Everyday Questions" },
        { type: "list", items: [
            "지금 몇 시예요? → What time is it now?",
            "오늘 몇 월 며칠이에요? → What’s today’s date?",
            "내일 몇 시에 만날까요? → What time shall we meet tomorrow?"
        ] },
        { type: "subheader", content: "Common Expressions" },
        { type: "list", items: [
            "조금 있다가 → in a little while",
            "지금 바로 → right now",
            "일찍 → early",
            "늦게 → late",
            "곧 → soon"
        ] },
        { type: "subheader", content: "Examples" },
        { type: "list", items: [
            "지금 바로 시작해요. → Let’s start right now.",
            "내일 일찍 일어나야 해요. → I have to wake up early tomorrow.",
            "조금 있다가 전화할게요. → I’ll call you in a little while."
        ] },
        { type: "paragraph", content: "Tip: Combining these expressions with clock times, days, or dates makes your conversations sound more fluent and natural." }
    ]
  },

 }
 
 
   //Make overveiw the default catgory selected when page loads
   const [selectedCategory, setSelectedCategory] = useState("Time_DL_Overview");
 
 
   return (
     <div>
       
       <HeaderNavNTM GoBack_to="/TimeNav" />
 
       <div className="blue-header-dlook">
         <img
           className="DeeperLookImage-dlook"
           src={DeeperLookIcon_Trans}
           alt="Deeper Look"
         />
       </div>

       <div className="panel-container-dlook">

         <div className="side-panel-dlook">
           {Object.keys(categories).map(key => (

             <p
               key={key}

               className={key === selectedCategory 
                 ? "category-active" 
                 : "category-inactive"}

               onClick={() => setSelectedCategory(key)}
             >              
               {categories[key].title}
             </p>
           ))}
         </div>
 
         {/* Text panel */}
     <div className="text-panel-dlook">
        {(categories[selectedCategory]?.content ?? []).map((item, index) => {

 
            switch (item.type) {

  
             case "subheader":
                 return <h3 key={index} className="subheader-dlook">{item.content}</h3>;
 
             case "paragraph":
                 return <p key={index}>{item.content}</p>;
 
             case "list":
                 return (
                 <ul key={index} className="list-dlook">
                     {item.items.map((bullet, i) => (
                     <li key={i}>{bullet}</li>
                     ))}
                 </ul>
                 );
 
             case "table":
                 return (
                 <table key={index} className="table-dlook">
                     <tbody>
                     {item.rows.map((row, r) => (
                         <tr key={r}>
                         {row.map((cell, c) => (
                             <td key={c}>{cell}</td>
                         ))}
                         </tr>
                     ))}
                     </tbody>
                 </table>
                 );
 
             default:
                 return null;

             }
             })}
         </div>
 
       </div>
      
       {/* End Body */}
     
     
     
     </div>
   );{/* End return */}
 } 
 
